

import React, { useEffect, useState } from 'react';
import {
  Layout, Row, Card, Form, Select, Button, Input, Typography, List, Switch, Space, message, Divider, Modal
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Header } from '../../component/header/header';
import Sidebar from '../../component/siderbar/sidebar';
import './configurations.css';
import { useHistory } from 'react-router-dom';

const { Content } = Layout;
const { Title } = Typography;
const { Option } = Select;

const KPI_OPTIONS = [
  'Baggage Detection',
  'Number Plate',
  'Face Recognition',
  'FireSmoke Detection',
  'PPE Detection',
  'ForeignMaterial Detection'
];

const STORAGE_KEY = 'rtspConfigs_v1';

export const HARDCODED_CONFIGS = [
    {
      id: 'cfg-1001',
      name: 'Sales Room',
      rtsp: 'rtsp://admin:password@12.45.1.10:554/stream1',
      kpi: 'Face Recognition',
      active: false,
      createdAt: '2025-10-14T08:00:00Z',
      hardcoded: true
    },
    {
      id: 'cfg-1002',
      name: 'Manufacturing Unit Camera 1',
      rtsp: 'rtsp://admin:password@12.45.1.10:554/stream2',
      kpi: 'FireSmoke Detection',
      active: false,
      createdAt: '2025-10-13T18:30:00Z',
      hardcoded: true
    }
  ];




export default function Configurations() {
  const [form] = Form.useForm();
  const history = useHistory();
  const [configs, setConfigs] = useState([]);
  const [loader] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  
  

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const stored = raw ? JSON.parse(raw) : [];

      // merge: keep hardcoded first, allow stored items to override by id,
      // and append any stored items that are not in hardcoded list
      const storedById = Object.fromEntries((stored || []).map(s => [s.id, s]));
      const mergedHardcoded = HARDCODED_CONFIGS.map(h => storedById[h.id] ? { ...h, ...storedById[h.id] } : h);
      const extraStored = (stored || []).filter(s => !HARDCODED_CONFIGS.some(h => h.id === s.id));
      setConfigs([...extraStored, ...mergedHardcoded]);
    } catch (e) {
      setConfigs(HARDCODED_CONFIGS);
    }
  }, []);

  useEffect(() => {
    try {
        const toPersist = configs.filter(c => !c.hardcoded);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(toPersist));
      } catch (e) {
        // ignore storage errors
      } 
    }, [configs]);

  const addConfig = (values) => {
    const rtsp = (values.rtsp || '').trim();
    if (!rtsp) {
      message.error('RTSP URL is required');
      return;
    }
    
    const newConfig = {
      id: Date.now().toString(),
      name: values.name || '',
      rtsp,
      kpi: values.kpi,
      active: values.active === undefined ? false : values.active,
      createdAt: new Date().toISOString(),
    };
    setConfigs([newConfig, ...configs]);
    form.resetFields();
    setModalVisible(false);
    message.success('Configuration added');
  };

  const toggleActive = (id) => {
    setConfigs(configs.map(c => c.id === id ? { ...c, active: !c.active } : c));
  };

  const removeConfig = (id) => {
    setConfigs(configs.filter(c => c.id !== id));
    message.success('Configuration removed');
  };

  const openDashboard = () => history.push('/dashboard');

  return (
    <div>
      <Layout>
        <Header />
        <Layout>
          <Sidebar currentKey={"5"} />

          <Content style={{ padding: '20px' }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: 8 }}>
              <Title className="title" level={2}>Configurations</Title>
              <div>
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)}>
                 Add Stream
                </Button>
              </div>
            </Row>
            <div>

            <Divider />

              <Row style={{ width: '100%' }}>
                <List style={{ width: '100%' }}
                  dataSource={configs}
                  locale={{ emptyText: 'No RTSP streams configured' }}
                  renderItem={item =>( 
                    <List.Item style={{width: '100%', maxWidth: '1100px', margin: '0 auto',}}>
                      <div className="rtsp-rect">
                        <div className="rtsp-rect-left">
                          <div className="rtsp-rect-title">{item.name || item.kpi}</div>
                        
                        <div className="rtsp-rect-line">
                          <span className="label">RTSP URL: </span>
                          <span className="value">{item.rtsp}</span>
                        </div>

                        <div className="rtsp-rect-line">
                          <span className="label">KPI: </span>
                          <span className="value">{item.kpi}</span>
                        </div>

                        <div className="rtsp-meta small">Added Date: {new Date(item.createdAt).toLocaleString()}</div>

                        <div className="rtsp-rect-bottom">
                            <Switch checked={item.active} onChange={() => toggleActive(item.id)} />
                            <span className="rtsp-status">{item.active ? '       Processing Active' : 'Processing Inactive'}</span>
                        </div>
                        </div>

                        <div className="rtsp-rect-right">
                            <Button danger shape="circle" icon={<DeleteOutlined />} onClick={() => removeConfig(item.id)} />
                       </div>
                            
                        
                      </div>
                    </List.Item>
                  )}
                />
              </Row>
            </div>

            <Modal
              title={<Title level={4}>Add RTSP Stream</Title>}
              visible={modalVisible}
              onCancel={() => { setModalVisible(false); form.resetFields(); }}
              footer={null}
              destroyOnClose
            >
              <Form
                layout="vertical"
                form={form}
                onFinish={addConfig}
                style={{ maxWidth: 700 }}
              >
                <Form.Item
                  label="Stream Name (optional)"
                  name="name"
                >
                  <Input placeholder="Friendly name (e.g. Entrance Cam 1)" />
                </Form.Item>

                <Form.Item
                  label="RTSP URL"
                  name="rtsp"
                  rules={[{ required: true, message: 'Please enter RTSP URL' }]}
                >
                  <Input placeholder="rtsp://user:pass@host:554/stream" />
                </Form.Item>

                <Form.Item
                  label="KPI"
                  name="kpi"
                  initialValue={KPI_OPTIONS[0]}
                  rules={[{ required: true, message: 'Please select KPI' }]}
                >
                  <Select>
                    {KPI_OPTIONS.map(k => <Option key={k} value={k}>{k}</Option>)}
                  </Select>
                </Form.Item>


                <Form.Item style={{ marginBottom: 20 }}>
                  <Space align="center" size="middle">
                    <Form.Item
                      name="active"
                      valuePropName="checked"
                      initialValue={false}
                      noStyle
                    >
                      <Switch />
                    </Form.Item>
                    <span style={{ fontSize: 13 }}>Processing Active (toggle)</span>
                  </Space>
                </Form.Item>

                <Form.Item>
                  <Space>
                    <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>Add Stream</Button>
                    <Button onClick={() => { form.resetFields(); setModalVisible(false); }}>Cancel</Button>
                  </Space>
                </Form.Item>
              </Form>
            </Modal>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}
